import { Context } from '@leverege/plugin';
import { Dialogs } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { Attributes } from '@leverege/ui-attributes';
import RemoveUsersDialog from "../user/RemoveUsersDialog.js";
const {
  t,
  tf
} = I18N.ns('userManagement.action.RemoveUsers');
export default {
  id: 'userManagement.action.RemoveUsers',
  type: 'ResourceUsers.remove',
  name: tf('name'),
  layout: {
    sort: 'remove'
  },
  matches: {
    use: 'contextMenu',
    client: 'ResourceUsers'
  },
  appearance: opts => {
    const {
      context
    } = opts;
    const users = Context.getTargetsOfType(context, 'user');
    const disabled = users == null || users.length === 0;
    const name = t('appearanceName', {
      count: users.length
    });
    return {
      name,
      disabled,
      visible: true
    };
  },
  handles: context => {
    const {
      clientProps: {
        allowed
      }
    } = context;
    return allowed.createUser === true && Context.hasTargetsOfType(context, 'user');
  },
  perform: ({
    context
  }) => {
    const users = Context.getTargetsOfType(context, 'user');
    const {
      actions,
      api,
      emailOptions,
      smsOptions,
      uiName,
      clientProps: {
        parentItem
      }
    } = context;
    const nameAttr = Attributes.getAttribute('name', parentItem?.type);
    Dialogs.show({
      component: RemoveUsersDialog,
      props: {
        userIds: users?.map(u => typeof u === 'string' ? u : u.id) || [],
        actions,
        api,
        emailOptions,
        smsOptions,
        uiName,
        deviceName: parentItem ? nameAttr.get(parentItem.data) : 'the system'
      }
    });
  }
};